import api from "../../services/api";
import * as actionTypes from "./actionTypes";

const getMeetingRecordingStart = () => {
  return {
    type: actionTypes.GET_SPECIFIC_MEETING_RECORDING_START,
  };
};

const getMeetingRecordingSuccess = (recordingData, meetingId) => {
  return {
    type: actionTypes.GET_SPECIFIC_MEETING_RECORDING_SUCCESS,

    videoUrl: recordingData.url,
  };
};

const getMeetingRecordingFail = (error) => {
  return {
    type: actionTypes.GET_SPECIFIC_MEETING_RECORDING_FAIL,
    error: error,
  };
};

export const getMeetingRecording = (accessToken, meetingId, seconds) => {
  const cleanMeetingDetailsResponse = (response, seconds) => {
    const body = response.data;
    return {
      name: body.name,
      url: seconds ? body.video_url + "#t=" + seconds : body.video_url,
      expirationTime: body.expiration_time,
      recordingAvailable: body.recording_available,
      startTime: body.start_time,
      endTime: body.end_time,
    };
  };

  return (dispatch) => {
    dispatch(getMeetingRecordingStart());
    return api.meetings
      .getMeetingRecording(accessToken, meetingId)
      .then((response) => {
        dispatch(
          getMeetingRecordingSuccess(
            cleanMeetingDetailsResponse(response, seconds),
            meetingId
          )
        );
        return response;
      })
      .catch((error) => {
        console.log("Meeting recording api call failed:");
        console.log(error);
        dispatch(getMeetingRecordingFail(error));
      });
  };
};
/****************************************
             GET SPECIFIC MEETING
 *****************************************/

const getSpecificMeetingStart = () => {
  return {
    type: actionTypes.GET_SPECIFIC_MEETING_DETAILS_START,
  };
};

const getSpecificMeetingSuccess = (response, host) => {
  return {
    type: actionTypes.GET_SPECIFIC_MEETING_DETAILS_SUCCESS,
    meetingid: response.id,
    meetingName: response.name,
    attendees: response.attendees,
    host: host,
  };
};

const getSpecificMeetingFail = (error) => {
  return {
    type: actionTypes.GET_SPECIFIC_MEETING_DETAILS_FAIL,
    error: error,
  };
};

export const getSpecificMeeting = (accessToken, meetingId) => {
  const findMeetingHost = (attendees) => {
    const host = attendees?.find((attendee) => attendee.role === "host");

    if (host) {
      return host;
    } else {
      console.log("this meeting have no host");
      return;
    }
  };
  return async (dispatch) => {
    dispatch(getSpecificMeetingStart());
    try {
      const response = await api.meetings.getMeeting(accessToken, meetingId);
      const host = findMeetingHost(response.data.attendees);
      dispatch(getSpecificMeetingSuccess(response.data, host));
      return response;
    } catch (error) {
      console.log("Get Specific Meeting API call failed for voice content:");
      console.log(error);
      dispatch(getSpecificMeetingFail(error));
    }
  };
};

export const clearSpecificMeetingStates = () => {
  return {
    type: actionTypes.CLEAR_SPECIFIC_MEETING_STATES,
  };
};
/****************************************
             Search Voice in SPECIFIC MEETING
 *****************************************/

const searchVoiceInMeetingStart = () => {
  return {
    type: actionTypes.SEARCH_VOICE_IN_MEETING_START,
  };
};

const searchVoiceInMeetingSuccess = () => {
  return {
    type: actionTypes.SEARCH_VOICE_IN_MEETING_SUCCESS,
  };
};

const searchVoiceInMeetingFail = (error) => {
  return {
    type: actionTypes.SEARCH_VOICE_IN_MEETING_FAIL,
    error: error,
  };
};

export const searchVoiceInMeeting = (accessToken, query, meetingId) => {
  return async (dispatch) => {
    console.log("Search Voice in Meeting Called");
    dispatch(searchVoiceInMeetingStart());
    try {
      const response = await api.search.meetingVoiceContent(
        accessToken,
        query,
        meetingId
      );
      console.log("Search Voice in Meeting Called successfull");

      dispatch(searchVoiceInMeetingSuccess());
      return response;
    } catch (error) {
      console.log("Search Voice in Meeting Called API call failed ");
      console.log(error);
      dispatch(searchVoiceInMeetingFail(error));
    }
  };
};
/****************************************
             Search text in SPECIFIC MEETING
 *****************************************/

const searchTextInMeetingStart = () => {
  return {
    type: actionTypes.SEARCH_TEXT_IN_MEETING_START,
  };
};

const searchTextInMeetingSuccess = () => {
  return {
    type: actionTypes.SEARCH_TEXT_IN_MEETING_SUCCESS,
  };
};

const searchTextInMeetingFail = (error) => {
  return {
    type: actionTypes.SEARCH_TEXT_IN_MEETING_FAIL,
    error: error,
  };
};

export const searchTextInMeeting = (accessToken, query, meetingId) => {
  return async (dispatch) => {
    console.log("Search Text in Meeting Called");
    dispatch(searchTextInMeetingStart());
    try {
      const response = await api.search.meetingTextContent(
        accessToken,
        query,
        meetingId
      );
      console.log("Search Text in Meeting Called successfull");

      dispatch(searchTextInMeetingSuccess());
      return response;
    } catch (error) {
      console.log("Search Text in Meeting Called API call failed ");
      console.log(error);
      dispatch(searchTextInMeetingFail(error));
    }
  };
};
